/* Blog index — transposes Blog.tsx filtering: search box + category pills filter the
   article grid client-side; the Featured section hides while any filter is active. */
(function () {
  var root = document.querySelector('[data-blog-root]');
  if (!root) return;

  var search = root.querySelector('[data-blog-search]');
  var pills = Array.prototype.slice.call(root.querySelectorAll('[data-blog-cat]'));
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-blog-card]'));
  var featured = root.querySelector('[data-blog-featured]');
  var heading = root.querySelector('[data-blog-heading]');
  var count = root.querySelector('[data-blog-count]');
  var none = root.querySelector('[data-blog-none]');
  var grid = root.querySelector('[data-blog-grid]');
  var clearBtn = root.querySelector('[data-blog-clear]');

  var activeCat = 'all';

  var ACTIVE = ['bg-primary', 'text-primary-foreground', 'hover:bg-primary/90'];
  var INACTIVE = ['border', 'border-input', 'bg-background', 'hover:bg-accent', 'hover:text-accent-foreground'];

  function paint() {
    pills.forEach(function (p) {
      var on = p.getAttribute('data-blog-cat') === activeCat;
      ACTIVE.forEach(function (c) { p.classList.toggle(c, on); });
      INACTIVE.forEach(function (c) { p.classList.toggle(c, !on); });
    });
  }

  function apply() {
    var q = (search && search.value ? search.value : '').trim().toLowerCase();
    var filtering = activeCat !== 'all' || q.length > 0;
    if (featured) featured.style.display = filtering ? 'none' : '';

    var visible = 0;
    cards.forEach(function (card) {
      var okCat = activeCat === 'all' || card.getAttribute('data-category') === activeCat;
      var okQ = !q || card.getAttribute('data-haystack').indexOf(q) !== -1;
      var show = okCat && okQ;
      card.style.display = show ? '' : 'none';
      if (show) visible++;
    });

    if (heading) {
      var name = 'All Articles';
      if (activeCat !== 'all') {
        var pill = pills.filter(function (p) { return p.getAttribute('data-blog-cat') === activeCat; })[0];
        name = pill ? pill.getAttribute('data-blog-cat-name') : name;
      }
      heading.textContent = name;
    }
    if (count) count.textContent = visible + (visible === 1 ? ' article' : ' articles');
    if (none) none.style.display = visible === 0 ? '' : 'none';
    if (grid) grid.style.display = visible === 0 ? 'none' : '';
    paint();
  }

  pills.forEach(function (p) {
    p.addEventListener('click', function () {
      activeCat = p.getAttribute('data-blog-cat');
      apply();
    });
  });
  if (search) search.addEventListener('input', apply);
  if (clearBtn) clearBtn.addEventListener('click', function () {
    activeCat = 'all';
    if (search) search.value = '';
    apply();
  });

  paint();
})();
